<!--
    Styles
-->

<style scoped>
/* cf. https://www.w3schools.com/howto/howto_css_switch.asp */

.ui-toggle {
  position: relative;
  height: 28px;
  background: var(--cl-powder-gray);
  cursor: pointer;
  border-radius: 14px;
}

.ui-toggle.active {
  background-color: var(--cl-orange);
}

.ui-toggle .slider {
  position: absolute;
  content: "";
  height: 20px;
  border-radius: 13px;
  left: 4px;
  top: 4px;
  transition: 0.2s;
  background-color: var(--cl-white);
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
  z-index: 0;
}
</style>

<!--
    Template
-->

<template>
  <button
    type="button"
    class="ui-toggle u-row"
    :class="{ active: value }"
    :style="{ width: width + 'px' }"
    @click="$emit('update:value', !value)"
  >
    <div class="slider" :style="{ width: widths.slider + 'px', transform }" />
  </button>
</template>

<!--
    Scripts
-->

<script lang="ts">
export default {
  props: {
    value: Boolean,
    width: {
      type: Number,
      default: 50,
    },
  },
  computed: {
    widths() {
      return {
        item: this.width / 2,
        slider: this.width / 2 - 5,
      };
    },
    transform() {
      return this.value
        ? `translateX(${this.width - this.widths.slider - 2 * 4}px)`
        : "none";
    },
  },
};
</script>
